import { render, staticRenderFns } from "./ftp-actions-delete.vue?vue&type=template&id=88cbfff4&"
import script from "./ftp-actions-delete.vue?vue&type=script&lang=js&"
export * from "./ftp-actions-delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports